import React, { Component } from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
`;

const ItemText = styled.ul`
  padding-right: 10px;
  flex-basis: 50%;
`;

const ItemImage = styled.ul`
  padding-left: 10px;
  flex-basis: 50%;
`;

// class Portfolio extends Component {
//   render() {
//     if(this.props.data){
//       var projects = this.props.data.projects.map(function(projects){
//         var projectImage = 'images/portfolio/'+projects.image;
//         return <div key={projects.title} className="columns portfolio-item">
//            <div className="item-wrap">
//             <a href={projects.url} title={projects.title}>
//                <img alt={projects.title} src={projectImage} />
//                <div className="overlay">
//                   <div className="portfolio-item-meta">
//                  <h5>{projects.title}</h5>
//                      <p>{projects.category}</p>
//                   </div>
//                 </div>
//               {/* <div className="link-icon"><i className="fa fa-link"></i></div> */}
//               <div>{projects.description}</div>
//             </a>
//           </div>
//         </div>
//       })
//     }

//     return (
//       <section id="portfolio">
//         <div className="row">
//           <div className="twelve columns collapsed">
//             {/* <h1>Check Out Some of My Works. Coming soon!</h1> */}

//             <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
//                 {projects}
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }
// }

// export default Portfolio;

class Portfolio extends Component {
  render() {
    if(this.props.data){
      var projects = this.props.data.projects.map(function (projects) {
        let projectImage = 'images/portfolio/'+ projects.image
        let project = (<div key={projects.title}>
        <h3>{projects.title}</h3>
        <p>{projects.description}</p>
        </div>);
        if (projects.image) {
          project = (<div key={projects.title}>
            <h3>{projects.title}</h3>
            <Container>
              <ItemText>
            {projects.description}
            </ItemText>
            <ItemImage>
            <img alt={projects.title} src={projectImage} />
            </ItemImage>
            </Container>
            </div>);
        }
        return project;
      });
    }
    return (
      <section id="portfolio" className="resume" style={{"background": "#ebeeee"}}>
        <div className="row">
          <div className="three columns header-col">
            <h1>
              <span>Projects</span>
            </h1>
          </div>

          <div className="nine columns main-col">{projects}</div>
        </div>
      </section>
    );
  }
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/Components/Portfolio.js